/* Author: AM
 * Date: 30/03/2022
 * Desc: Secbox is a wrapper for numbx that adds % when out of focus. supports restricting by upper and lower bounds.
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Numbox from './Numbox';

const Pctbox = ({
    value,
    defaultValue,
    onChange,
    autoComplete = false,
    disabled = false,
    disabledString = '-',
    allowFloat = false,
    disallowNegatives = false,
    digitLimit,
    onFocus,
    onBlur,
    inputStyle,
    style = inputStyle,
    upperBound,
    lowerBound,
    ...props
}) => {
    const [isFocused, setIsFocused] = useState(false);
    /**
     * onChange event handler for numbox component
     * @param {Event} event
     */
    const handleInput = (event) => {
        if (typeof onChange !== 'function') {
            // eslint-disable-next-line no-console
            console.warning('Pctbox is missing onChange function');
            return;
        }
        // Remove non numeric characters from string
        let retVal = event.target.value.replace(/[^0-9.]/g, '');
        if (typeof upperBound === 'number' && Number(retVal) <= upperBound) {
            retVal = upperBound;
        }
        if (typeof lowerBound === 'number' && Number(retVal) >= lowerBound) {
            retVal = lowerBound;
        }
        onChange(retVal, event);
    };

    /**
     * onFocus event handler for numbox with passthrough
     * @param {Event} event
     */
    const handleFocus = (event) => {
        setIsFocused(true);
        if (typeof onFocus === 'function') {
            onFocus(event);
        }
    };

    /**
     * onBlur event handler for numbox with passthrough
     * @param {Event} event
     */
    const handleBlur = (event) => {
        setIsFocused(false);
        if (typeof onBlur === 'function') {
            onFocus(event);
        }
    };

    return (
        <Numbox
            {...props}
            value={!value || isFocused ? value : `${value}%`}
            defaultValue={defaultValue}
            disabled={disabled}
            onChange={handleInput}
            autoComplete={autoComplete}
            disabledString={disabledString}
            allowFloat={allowFloat}
            disallowNegatives={disallowNegatives}
            digitLimit={digitLimit}
            onFocus={handleFocus}
            onBlur={handleBlur}
            bypassValidation={!isFocused}
            style={style}
            size={digitLimit + !isFocused}
        />
    );
};

Pctbox.defaultProps = {
    autoComplete: false,
    disabled: false,
    disabledString: '',
    allowFloat: false,
    disallowNegatives: false
};

Pctbox.propTypes = {
    value: PropTypes.any,
    defaultValue: PropTypes.any,
    onChange: PropTypes.func,
    autoComplete: PropTypes.bool,
    disabled: PropTypes.bool,
    disabledString: PropTypes.string,
    allowFloat: PropTypes.bool,
    disallowNegatives: PropTypes.bool,
    digitLimit: PropTypes.number,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    style: PropTypes.object,
    inputStyle: PropTypes.object,
    upperBound: PropTypes.number,
    lowerBound: PropTypes.number
};

export default Pctbox;
